import React, { useState } from 'react';
import { Card, Button } from 'react-bootstrap';
import { FaSitemap, FaDownload } from 'react-icons/fa';
import axios from 'axios';
import '../styles/organigramaCard.css';

const API_URL = process.env.REACT_APP_API_URL || 
  (process.env.NODE_ENV === 'development' ? 'http://localhost:4004' : '');

const OrganigramaCard = ({ userData }) => {
  const [loading, setLoading] = useState(false);

  const registrarAcceso = async (accion) => {
    try {
      const token = localStorage.getItem('token');
      console.log('🔍 [FRONTEND] Registrando acceso:', { accion, token: token ? 'Existe' : 'NO existe' });
      
      const response = await axios.post(
        `${API_URL}/api/organigrama/registrar-acceso`,
        { accion },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      console.log('✅ [FRONTEND] Respuesta del servidor:', response.data);
    } catch (error) {
      console.error('❌ [FRONTEND] Error al registrar acceso:', error);
      console.error('Detalles del error:', error.response?.data || error.message);
    }
  };

  const handleVerOrganigrama = async () => {
    setLoading(true);
    const pdfPath = '/assets/organigrama/ORGANIGRAMA.pdf';
    
    try {
      // Registrar que vio el organigrama
      await registrarAcceso('ver');
      
      // Abrir PDF
      window.open(pdfPath, '_blank');
    } catch (error) {
      console.error('Error al abrir el organigrama:', error);
      alert('No se pudo abrir el organigrama. Por favor, contacte al administrador.');
    } finally {
      setTimeout(() => setLoading(false), 500);
    }
  };

  const handleDescargarOrganigrama = async () => {
    const pdfPath = '/assets/organigrama/ORGANIGRAMA.pdf';
    
    try {
      // Registrar que descargó el organigrama
      await registrarAcceso('descargar');
      
      // Descargar PDF
      const link = document.createElement('a');
      link.href = pdfPath;
      link.download = 'Organigrama-Sibus.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error al descargar:', error);
    }
  };

  return (
    <Card className="organigrama-card">
      <div className="organigrama-content">
        <div className="organigrama-header">
          <div className="organigrama-icon-wrapper">
            <div className="organigrama-icon-bg">
              <FaSitemap className="organigrama-icon" />
            </div>
          </div>
          
          <div className="organigrama-info">
            <h3 className="organigrama-title">
              Organigrama Corporativo
            </h3>
            <p className="organigrama-description">
              Estructura organizacional y jerarquía de SiBus
            </p>
          </div>
        </div>
        
        <div className="organigrama-actions">
          <Button 
            variant="primary" 
            className="organigrama-btn organigrama-btn-view"
            onClick={handleVerOrganigrama}
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2"></span>
                Abriendo...
              </>
            ) : (
              <>
                <FaSitemap className="me-2" />
                Ver Organigrama
              </>
            )}
          </Button>
          
          <Button 
            variant="outline-primary" 
            className="organigrama-btn organigrama-btn-download"
            onClick={handleDescargarOrganigrama}
          >
            <FaDownload className="me-2" />
            Descargar
          </Button>
        </div>
      </div>
    </Card>
  );
};

export default OrganigramaCard;
